export default function handleShare() {
  function init() {
    const shareToggle = document.querySelector('.js-mod-share-trigger');
    const shareContent = document.querySelector('.js-mod-share-content');
    const toggleClass = 'visuallyhidden';
    // const shareUrl = document.querySelector('.js-mod-share-url');

    function toggleShareContent() {
      shareContent.classList.toggle(toggleClass);
    }

    // function copyShareUrl() {
    //   shareUrl.select();
    //   if (!document.execCommand('copy')) {
    //     // copy is not supported — fall back to something else.
    //   } else {
    //     document.execCommand('copy');
    //     // Maybe do *more*, here, to let the user know the URL has been copied to
    //     // their clipboard.
    //   }
    // }

    shareToggle.addEventListener('click', toggleShareContent);
    // shareUrl.addEventListener('click', copyShareUrl);
  }

  const share = document.querySelector('.js-mod-share');

  if (share === null) {
    return false;
  } else {
    init();
  }
}
